import { Component, Input } from '@angular/core';
import { ProductKey } from 'src/app/core/enums/ProductKey';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.scss'],
})
export class CancellationPolicyComponent {
  @Input() summaryData: SummaryData = {} as SummaryData;
  @Input() currentStep = 0;


  shouldShowCancellationPolicy(): boolean {
    return (
      this.currentStep > 3 && this.summaryData.productInformation.product?.ProductKey != null &&
      (this.summaryData.productInformation.product?.ProductKey !==
        ProductKey.MotHomologation ||
        this.currentStep > 5)
    );
  }

  isMediumLongDistanceTransfer(): boolean {
    return (
      this.summaryData.productInformation.product?.ProductKey ===
      ProductKey.MediumLongDistance
    );
  }
}
